import React, { FC, FocusEvent, useState, ReactNode } from 'react';
import classNames from 'classnames';
import ClickAwayListener from 'react-click-away-listener';
import { PartialsBackgroundVariants } from './PartialsBackgroundVariants';

export interface TextareaProps {
  label: string;
  name: string;
  onValueChange: (inputValue: string) => void;
  className?: string;
  placeholder?: string;
  maxLength?: number;
  error?: string;
  required?: boolean;
  requiredText?: string | ReactNode | Element;
  backgroundVariant?: PartialsBackgroundVariants;
  disabled?: boolean;
  hideLabel?: boolean;
};

export const Textarea: FC<TextareaProps> = (props) => {
  const [isTextareaFocused, setIsTextareaFocused] = useState(false);
  const [inputValue, setInputValue] = useState('');

  const {
    label,
    name,
    error,
    className,
    onValueChange,
    maxLength,
    placeholder,
    requiredText,
    required = false,
    backgroundVariant = 'light',
    disabled = false,
    hideLabel = false
  } = props;

  const id = `insuranceTextarea-${name}`

  const handleBlur = (e: FocusEvent<HTMLTextAreaElement>) => {
    const value = e.target.value;

    if (!value) {
      setIsTextareaFocused(false);
    }

    setInputValue(value);
    onValueChange(value);
  }

  return (
    <ClickAwayListener onClickAway={() => setIsTextareaFocused(false)}>
      <div className={classNames("insuranceTextarea", className, {
        "insuranceTextarea--error": error,
        "insuranceTextarea--disabled": disabled,
      })}>
        <label
          className={classNames('insuranceTextarea__label', {
            "insuranceTextarea__label--focus": !!inputValue || isTextareaFocused || placeholder,
            "visually-hidden": hideLabel,
          })}
          htmlFor={id}
        >
          {label} {required && requiredText}
        </label>
        <div className="insuranceTextarea__inner">
          <textarea
            className={classNames('insuranceTextarea__field', {
              'insuranceTextarea__field--light': backgroundVariant === 'light',
              'insuranceTextarea__field--blueLight': backgroundVariant === 'blue-light'
            })}
            onFocus={() => setIsTextareaFocused(true)}
            onBlur={handleBlur}
            id={id}
            name={name}
            placeholder={placeholder}
            required={required}
            maxLength={maxLength}
            aria-describedby={"errorId-" + id}
            disabled={disabled}
          />
        </div>
        {error && (
          <div className='insuranceTextarea__error'>
            <p id={"errorId-" + id} className="fs-6 insuranceTextarea__errorText">
              {error}
            </p>
          </div>
        )}
      </div>
    </ClickAwayListener>
  )
}
